import { Box, Tooltip, Typography } from "@mui/material";
import { CheckCircle as CheckCircleIcon, Warning as WarningIcon, Error as ErrorIcon } from "@mui/icons-material";
import { AlertType, ValidationError } from "@/types";
import { ColorType } from "@/types/shared/uiComponents";

interface ValidationErrorsCellProps {
  errors: ValidationError[];
}

/**
 * Displays validation status with error/warning counts
 */
export const ValidationErrorsCell = ({ errors }: ValidationErrorsCellProps) => {
  if (errors.length === 0) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CheckCircleIcon color={ColorType.Success} fontSize="small" />
        <Typography variant="body2" color="success.main">
          Ready
        </Typography>
      </Box>
    );
  }

  const errorCount = errors.filter((e) => e.severity === AlertType.ERROR).length;
  const warningCount = errors.filter((e) => e.severity === AlertType.WARNING).length;

  const errorMessages = errors.map((e) => `${e.severity.toUpperCase()}: ${e.message}`).join("\n");

  return (
    <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{errorMessages}</span>} arrow>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {errorCount > 0 && (
          <>
            <ErrorIcon color="error" fontSize="small" />
            <Typography variant="body2" color="error.main">
              {errorCount}
            </Typography>
          </>
        )}
        {warningCount > 0 && (
          <>
            <WarningIcon color="warning" fontSize="small" />
            <Typography variant="body2" color="warning.main">
              {warningCount}
            </Typography>
          </>
        )}
      </Box>
    </Tooltip>
  );
};
